<template>
  <a-modal :visible="visible" :title="$t('warningOrder.handleMethod')" :width="1280" @cancel="closeModal" @ok="sendhandleMethods">
    <div class="search">
      <a-form-model layout="inline">
        <a-form-model-item :label="$t('device.warningType')">
          <a-select style="width: 200px;" v-model="selectedWarningType" @change="renderCards">
            <a-select-option value="">
              {{ $t("common.all") }}
            </a-select-option>
            <a-select-option v-for="(v, k) in warningCodeNameMap" :key="k">
              {{ v[lang] }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item :label="$t('warningOrder.handleMethod')">
          <a-input v-model="handleMethodContentToSearch" style="width: 200px;" @keyup.enter="searchHandleMethod" />
        </a-form-model-item>
      </a-form-model>
      <div>
        <a-button v-if="isAddHandleMethodButtonShow" type="primary" style="margin-right: 10px;" @click="addHandleMethod">{{ $t("buttons.add") }}</a-button>
        <a-button type="primary" @click="searchHandleMethod">{{ $t("buttons.search") }}</a-button>
      </div>
    </div>
    <div v-loading="isLoading">
      <a-empty v-show="handleMethods.length === 0 && !isHandleMethodInputing">
        <span slot="description">{{ $t('warningOrder.noHandleMethods') }}</span>
      </a-empty>
      <div class="cardsGroup" ref="cardsGroup">
        <el-card style="width: 18.5%;" v-for="(r, i) in handleMethods" :key="r.code" :class="{ ml: i % 5 > 0, mr: i % 5 < 4 }">
          <div slot="header" class="clearfix">
            <h3 style="display: flex; justify-content: space-between; cursor: pointer; font-size: 16px">
              {{ warningCodeNameMap[r.warningType] ? warningCodeNameMap[r.warningType][lang] : "" }}
              <span class="buttonsGroup">
                <a-button style="padding-right: 6px;" v-if="isUpdateHandleMethodButtonShow" :loading="r.isLoading" type="link" @click="switchEditStatus(r)">{{ r.isEditing ? $t("buttons.save") : $t("buttons.edit") }}</a-button>
                <a-button style="padding-right: 6px;" v-if="r.isEditing" type="link" @click="cancelEdit(r, i)">{{ $t("common.cancelText") }}</a-button>
                <a-button v-if="isDeleteHandleMethodButtonShow" type="link" style="color: red; padding: 0;" @click="confirmToDelete(r, i)">{{ $t("buttons.delete") }}</a-button>
              </span>
            </h3>
          </div>
          <p style="display: flex; align-items: center; margin-bottom: 6px">
            {{ $t("warningOrder.handleMethod") }}：
            <a-input style="flex: 1;" v-if="r.isEditing" v-model="r.handleMethod_temp" />
            <template v-else>{{ r.handleMethod }}</template>
          </p>
          <p style="display: flex; align-items: center;">{{ $t("common.remark") }}：
            <a-input style="flex: 1;" v-if="r.isEditing" v-model="r.remark_temp" />
            <template v-else>{{ r.remark }}</template>
          </p>
        </el-card>
      </div>
    </div>
  </a-modal>
</template>

<script>
import {
  gethandleMethodsItemList,
  insertHandleMethod,
  updateHandleMethod,
  deleteHandleMethod
} from "@/api/warningOrder"
import { nanoid } from "nanoid"

export default {
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    warningCodeNameMap: {
      type: Object,
      required: true
    },
    closeModal: {
      type: Function,
      required: true
    },
    handleConfirm: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      isLoading: false,
      selectedWarningType: "",
      handleMethodContentToSearch: "",
      handleMethods: [],
      isHandleMethodInputing: false,
      isAddHandleMethodButtonShow: false,
      isUpdateHandleMethodButtonShow: false,
      isDeleteHandleMethodButtonShow: false
    }
  },
  computed: {
    lang() {
      return this.$store.state.lang
    }
  },
  watch: {
    visible(v) {
      if (v) {
        this.renderCards()
      }
    }
  },
  created() {
    const a = this.getAuthorities("/warning/order")
    for (let i = 0; i < a.length; i++) {
      if (a[i].code === "warning:handleMethod:create") {
        this.isAddHandleMethodButtonShow = true
      }
      if (a[i].code === "warning:handleMethod:update") {
        this.isUpdateHandleMethodButtonShow = true
      }
      if (a[i].code === "warning:handleMethod:delete") {
        this.isDeleteHandleMethodButtonShow = true
      }
    }
  },
  methods: {
    async renderCards() {
      this.isLoading = true
      const handleMethods = await this.requestHandleMethodsItemList()
      handleMethods.sort((a, b) => a.priority - b.priority)
      this.orginHandleMethods = handleMethods
      this.handleMethods = handleMethods
      this.handleMethods.forEach(r => {
        if ((this.selectedHandleMethods || []).find(s => s === r.handleMethod)) {
          r.selected = true
        }
      })
      this.isLoading = false
    },
    async requestHandleMethodsItemList() {
      try {
        this.handleMethodContentToSearch = ""
        this.handleMethods = []
        const { data } = await gethandleMethodsItemList(this.selectedWarningType)
        return data
      } catch(e) {
        console.log(e)
        return []
      }
    },
    searchHandleMethod() {
      this.isLoading = true
      this.handleMethods = this.orginHandleMethods.filter(o => o.handleMethod.includes(this.handleMethodContentToSearch))
      this.isLoading = false
    },
    sendhandleMethods() {
      let pass = true, r, res = []
      for (let i = 0; i < this.handleMethods.length; i++) {
        r = this.handleMethods[i]
        if (r.selected) {
          if (r.isEditing) {
            pass = false
            break
          }
          if (r.handleMethod) {
            res.push(r.handleMethod)
          }
        }
      }
      if (pass) {
        this.handleConfirm(res)
      } else {
        this.$message.warning(this.$t("warningOrder.saveFirst"))
      }
    },
    async switchEditStatus(r) {
      r.isEditing = !r.isEditing
      if (r.isEditing) {
        r.handleMethod_temp = r.handleMethod
        r.remark_temp = r.remark
        r.priority_temp = r.priority
      } else {
        r.isLoading = true
        try {
          if (r.toAdd) {
            const { message } = await insertHandleMethod({
              warningType: r.warningType,
              handleMethod: r.handleMethod_temp,
              remark: r.remark_temp,
              priority: r.priority_temp
            })
            this.$message.success(message)
          } else {
            const { message } = await updateHandleMethod({
              code: r.code,
              warningType: r.warningType,
              handleMethod: r.handleMethod_temp,
              remark: r.remark_temp,
              priority: r.priority_temp
            })
            this.$message.success(message)
          }
          this.renderCards()
          this.isHandleMethodInputing = false
        } catch(e) {
          console.log(e)
        } finally {
          r.isLoading = false
        }
        delete r.handleMethod_temp
        delete r.remark_temp
        delete r.priority_temp
      }
      this.$forceUpdate()
    },
    addHandleMethod() {
      if (!this.selectedWarningType) {
        return this.$message.warning(this.$t("warning.swt"))
      }
      this.isHandleMethodInputing = true
      this.handleMethods.push({
        code: nanoid(),
        handleMethod: "",
        handleMethod_temp: "",
        remark: "",
        remark_temp: "",
        priority: "",
        priority_temp: "",
        toAdd: true,
        warningType: this.selectedWarningType,
        isEditing: true
      })
      this.$nextTick(() => {
        this.$refs.cardsGroup.scrollTo({
          top: this.$refs.cardsGroup.scrollHeight,
          behavior: "smooth"
        })
      })
    },
    f() {
      this.$forceUpdate()
    },
    confirmToDelete(r, i) {
      this.$confirm({
        title: this.$t("warningOrder.confirmToDeleteHandleMethod"),
        content: this.$t("warningOrder.confirmHandleMethod"),
        onOk: async () => {
          try {
            if (r.toAdd) {
              this.handleMethods.splice(i, 1)
            } else {
              const { message } = await deleteHandleMethod(r.code)
              this.$message.success(message)
              this.renderCards()
            }
          } catch (e) {
            console.log(e)
          }
        }
      })
    },
    cancelEdit(r, i) {
      r.isEditing = false
      delete r.reason_temp
      delete r.remark_temp
      delete r.priority_temp
      if (r.toAdd) {
        this.handleMethods.splice(i, 1)
      }
      this.$forceUpdate()
    }
  }
}
</script>

<style lang="less" scoped>
.cardsGroup {
  display: flex;
  flex-wrap: wrap;
  max-height: 520px;
  padding-top: 15px;
  overflow: auto;
  .el-card {
    margin-bottom: 2%;
    position: relative;
    font-size: 14px;
    h3 {
      margin: 0;
    }
    &.ml {
      margin-left: .8%;
    }
    &.mr {
      margin-right: .8%;
    }
    .buttonsGroup {
      float: right;
      button {
        padding-left: 0;
      }
    }
  }
}
.search {
  margin-bottom: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
/deep/ .el-card__header {
  padding: 8px 10px;
}
/deep/ .el-card__body {
  padding: 8px 10px;
  p {
    margin: 0;
    padding: 0;
  }
}
</style>